export const getQueryParams = (search) => {
  const query = new URLSearchParams(search);
  return {
    company_uuid: query.get("company_uuid"),
    template_type: query.get("template_type"),
    template: query.get("template"),
  };
};
export const getBreakDownQueryParams = (search) => {
  const query = new URLSearchParams(search);
  return {
    company_uuid: query.get("company_uuid"),
    template_type: query.get("template_type"),
    template: query.get("template"),
    interval: query.get("interval"), from_date: query.get("from_date"), to_date: query.get("to_date")
  };
};